module.exports = __webpack_public_path__ + "img/Patients-background.971d4c39.svg";